<div class="mobile-backdrop" [class.visible]="mobileMenuExpanded$ | async" (click)="closeMobileMenu()" aria-hidden="true"></div>
<div
  class="main-sidebar"
  [class.expanded]="!isCollapsed"
  [class.hidden]="isCollapsed"
  [class.mobile-open]="mobileMenuExpanded$ | async"
  role="navigation"
>
  <div class="sidebar-content">
    <div class="navigation-items-container">
      <div class="collapse-menu-container" [class.collapse-menu-container--hide-on-mobile]="hideCollapseMenuOnMobile">
        @if (backLink) {
          <a class="back-link" [class.hidden]="isCollapsed" [routerLink]="backLink.url">
            <ptl-icon [icon]="LucideChevronLeft" [size]="'s'"></ptl-icon>
            <span>{{ backLink.label }}</span>
          </a>
        }

        <ptl-button
          class="collapse-btn"
          type="tertiary-neutral"
          [size]="'xs'"
          [icon]="isCollapsed ? LucideChevronsRight : LucideChevronsLeft"
          (click)="onToggleCollapse()"
        ></ptl-button>
      </div>

      <div class="nav-content" [class.hidden]="isCollapsed">
        @if (type || title) {
          <div class="sidebar-title-container">
            <div *ngIf="type" class="sidebar-type fs-body-xs">
              <span class="title-text">{{ type }}</span>
            </div>
            <div *ngIf="title" class="sidebar-title fs-body-m semibold">
              <span class="title-text">{{ title }}</span>
            </div>
          </div>
        }
        <div class="sidebar-projected-content">
          <ng-content></ng-content>
        </div>

        <div class="sidebar-projected-footer">
          <ng-content select="[sidebarFooter]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
